import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_11CBlack_11BBlack = () => <CrossRoad coords="2238.000000, 662.000000"/>;
export default CrossRoad_11CBlack_11BBlack;
